import { useEffect, useState } from "react";
import { Moon, Sun } from "lucide-react";
import {
  applyThemeChoice,
  persistThemeChoice,
  readThemeChoice,
  resolveTheme,
  type ResolvedTheme,
} from "./theme";

/**
 * Alternância claro/escuro do protótipo (`#themeBtn`): lua no tema escuro,
 * sol no claro; o clique inverte o tema resolvido. A escolha fica no
 * dispositivo (`app/theme.ts`). O mesmo controle serve ao topo do shell e ao
 * painel de entrada — só a classe muda.
 */
export function ThemeToggle({ className = "zn-icon-btn" }: { className?: string }) {
  const [theme, setTheme] = useState<ResolvedTheme>(() => resolveTheme(readThemeChoice()));

  useEffect(() => {
    applyThemeChoice(readThemeChoice());
  }, []);

  const toggle = () => {
    const next: ResolvedTheme = theme === "dark" ? "light" : "dark";
    setTheme(next);
    persistThemeChoice(next);
    applyThemeChoice(next);
  };

  return (
    <button
      type="button"
      className={className}
      aria-label="Alternar tema claro/escuro"
      title={theme === "dark" ? "Mudar para o tema claro" : "Mudar para o tema escuro"}
      aria-pressed={theme === "light"}
      onClick={toggle}
    >
      {theme === "dark" ? <Moon size={17} aria-hidden="true" /> : <Sun size={17} aria-hidden="true" />}
    </button>
  );
}
